import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { PersonCircle } from "react-bootstrap-icons";
import PaymentViewCounter from "../PaymentViewCounter/PaymentViewCounter";

function UserViewCounter({ userData }) {
  const theme = useTheme();
  return (
    <Box sx={{ padding: "20px" }}>
      <Box
        className="user"
        sx={{ display: "flex", gap: "12px", marginBottom: "20px" }}
      >
        <PersonCircle size={24} />
        <Typography
          variant="h5"
          fontWeight={600}
          color={theme.palette.neutral[900]}
        >
          {userData?.name}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {userData?.PaymentMethods?.map((p, i) => (
          <PaymentViewCounter paymentData={p} key={i} />
        ))}
      </Box>
    </Box>
  );
}

export default UserViewCounter;
